export const hi = {
    /**
     * Main
     * 
     * @name No Particular Name
     * @file Overall exists in multiple files
     */
    "ToDo": "टोडो",
    "Todo List": "टोडो सूची",
    "Todo list for managing multiple tasks.": "कई कार्यों के प्रबंधन के लिए टोडो सूची।",

    /**
     * Switch Locale
     * 
     * @name SwitchLocale.js
     * @file src://Components/SwitchLocale.js
     */
    "Change Locale": "स्थान बदलें",

    /**
     * Sign In
     * 
     * @name SignIn.js
     * @file src://Pages/SignIn.js
     */
    "Sign In": "साइन इन करें",
    "Instead": "बजाय",
    "Password": "पासवर्ड",
    "Full Name": "पूरा नाम",
    "Remember me": "मुझे याद करो",
    "Loggin Successful": "Loggin सफल",
    "User not registered": "उपयोगकर्ता पंजीकृत नहीं है",
    "Invalid Credentials": "अमान्य क्रेडेंशियल्स",
    "Something went wrong": "कुछ गलत हो गया",
    "This field is invalid": "यह फ़ील्ड अमान्य है",
    "This field is required": "यह फ़ील्ड आवश्यक है",
    
    /**
     * Sign Up
     * 
     * @name SignUp.js
     * @file src://Pages/SignUp.js
     */
    "Sign Up": "नाम लिखो",
    "Select your avatar": "अपने अवतार का चयन करें",
    "User already exists": "उपयोगकर्ता पहले से मौजूद है",
    "Please select your avatar": "कृपया अपने अवतार का चयन करें",
    "User Successfully Registered": "उपयोगकर्ता सफलतापूर्वक पंजीकृत",
    "Selected avatar size too large": "चयनित अवतार का आकार बहुत बड़ा",
    
    /**
     * Todo List
     * 
     * @name TodoList.js
     * @file src://Pages/User/Tasks/TodoList.js
     */
    "User": "उपभोक्ता",
    "Task": "काम",
    "Loading": "लोड",
    "Status": "ओहदा",
    "Actions": "कार्यों",
    "Priority": "प्राथमिकता",
    "Edit Todo": "सभी संपादित करें",
    "Delete Todo": "कार्य हटाएँ",
    "User not found": "उपयोगकर्ता नहीं मिला",
    "No Result Found": "कोई परिणाम नहीं मिला",

    /**
     * Search Bar
     * 
     * @name SearchBar.js
     * @file src://Components/List/Helpers/SearchBar.js
     */
    "Items": "आइटम",
    "Search": "ढूँढ",
    "Type Here": "यहाँ टाइप करें",
    "Search for task": "कार्य की खोज करें",

    /**
     * Create Todo
     * 
     * @name CreateTodo.js
     * @file src://Pages/User/Tasks/Components/Models/CreateTodo.js
    */
    "Add": "जोड़ना",
    "Task": "काम",
    "Close": "बंद करना",
    "Status": "ओहदा",
    "Priority": "प्राथमिकता",
    "Task Work": "कार्य कार्य",
    "Create Todo": "कार्य बनाएँ",
    "Something went wrong": "कुछ गलत हो गया",
    "Task successfully created": "कार्य सफलतापूर्वक बनाया गया",

    /**
     * Edit Todo
     * 
     * @name EditTodo.js
     * @file src://Pages/User/Tasks/Components/Models/EditTodo.js
     */
    "Edit": "संपादन करना",
    "Edit Todo": "कार्य संपादित करें",
    "Something went wrong": "कुछ गलत हो गया",
    "Task successfuly update": "कार्य सफलतापूर्वक अद्यतन किया गया",

    /**
     * Delete Todo
     * 
     * @name DeleteTodo.js
     * @file src://Pages/User/Tasks/Components/Models/DeleteTodo.js
     */
    "Delete": "मिटाना",
    "Delete Todo": "कार्य हटाएँ",
    "Are You Sure": "क्या आपको यकीन है",
    "It can not be undone": "इसे पूर्ववत नहीं किया जा सकता",
    "Task successfuly deleted": "कार्य सफलतापूर्वक हटाया गया",
    
    /**
     * Mass Delete Todo
     * 
     * @name MassDeleteTodo.js
     * @file src://Pages/User/Tasks/Components/Models/MassDeleteTodo.js
     */
    "Mass Delete Todo": "बड़े पैमाने पर हटाएँ कार्य",
    
    /**
     * Progress
     * 
     * @name Progress.js
     * @file src://Components/List/Helpers/Progress.js
    */
    "Closed": "बंद",
    "Opened": "खोला",
    "Pending": "विचाराधीन",
    
    /**
     * Info Cards
     * 
     * @name InfoCards.js
     * @file src://Components/List/Helpers/InfoCards.js
     */
    "Low": "नीचा",
    "High": "उच्च",
    "Medium": "मध्यम",
    
    /**
     * NavBar
     * 
     * @name NavBar.js
     * @file src://Components/NavBar.js
     */
    "Profile": "रूपरेखा",
    "Nav Bar": "नेव बार",
    "Sign Out": "साइन आउट करें",
    "Exchanger": "एक्सचेंजर",
    "Select File": "फ़ाइल का चयन करें",
    "Signed in as": "के रूप में साइन इन किया",
    "Profile Edit": "प्रोफ़ाइल संपादित करें",

    /**
     * Profile
     * 
     * @name Profile.js
     * @file src://Pages/User/Settings/Profile.js
     */
    "Edit": "संपादन करना",
    "Edit Profile": "प्रोफ़ाइल संपादित करें",
    "Profile successfully updated": "प्रोफ़ाइल सफलतापूर्वक अद्यतन किया गया",
    "User already exists with same name": "उपयोगकर्ता पहले से ही समान नाम के साथ मौजूद है",

    /**
     * Exchanger
     * 
     * @name Exchanger.js
     * @file src://Pages/User/Settings/Exchanger.js
     */
    "Import": "आयात",
    "Export": "निर्यात",
    "File size too large": "फ़ाइल का आकार बहुत बड़ा",
    "Please select your file": "कृपया अपनी फ़ाइल का चयन करें",
    "Task successfully imported": "कार्य सफलतापूर्वक आयात किया गया",
    "Task successfully exported": "कार्य सफलतापूर्वक निर्यात किया गया",
    "Only these types are supported!": "केवल इन प्रकारों का समर्थन किया जाता है! [{{types, field}}]",
    "Import may over write your previous todos": "आयात आपके पिछले टोडो को ओवरराइट कर सकता है",
    
    /**
     * Exchanger
     * 
     * @name Error.js
     * @file src://Pages/Error.js
     */
    "404": "४०४",
    "Go to home": "घर जाओ",
    "This page could not be found.": "यह पृष्ठ ढूँढा नहीं जा सका.",
};